<template>
    <iframe name="pdf-box" :id="boxId" :src="src" border="none" :style="{border:'none',width:'100%',height:height+'px'}"></iframe>
</template>
<script>
import { getUUID } from "@/utils";
export default {
  name:'PdfViewer',
  props:{
    url:{
      type:String,
      default:''
    },
    height:{
      type:Number,
      default:500
    }
  },
  data(){
    return {
      boxId:'pdf',
      src:'',
      baseUrl:'/static/pdfjs/web/viewer.html?file='
    }
  },
  watch:{
    url:{
      handler:function(newVal){
        this.src=this.baseUrl+newVal+`?t=`+Date.now()
      },
      immediate:true
    }
  },
  mounted() {
    this.boxId=`pdfbox-`+getUUID()
  }
}
</script>
